export const sentry = {
  dsn: 'https://3f70fbc8bb2445f39b02d5cb68b15df7@o429979.ingest.sentry.io/5708416'
};